// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterBar-cls1_qQY","cls2":"FilterBar-cls2_QFu FilterBar-cls1_qQY"};